import { alpha, keyframes, styled, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const TransitionBar = styled('button', { name: 'SidekickTransitionBar' })(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexShrink: 0,
    margin: '0.25rem 0.375rem 0.375rem',
    padding: '0.5625rem 0.75rem',
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainer,
    border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
    borderRadius: '0.625rem',
    color: theme.palette.custom.OV.sys.onBackground,
    fontFamily: 'inherit',
    fontSize: '0.78125rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color .12s, border-color .12s',

    '&:hover': {
      backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
      borderColor: theme.palette.custom.OV.sys.outline,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.custom.OV.sys.primary}`,
      outlineOffset: '1px',
    },
  }),
);

export const TransitionBarSpark = styled('span', { name: 'SidekickTransitionBarSpark' })(
  ({ theme }) => ({
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
    color: theme.palette.custom.OV.sys.secondary,
  }),
);

const movedPulse = keyframes`
  0% { box-shadow: 0 0 0 0 var(--sidekick-pulse); }
  70% { box-shadow: 0 0 0 0.5rem transparent; }
  100% { box-shadow: 0 0 0 0 transparent; }
`;

export const getMovedTabSx = (theme: Theme): SystemStyleObject<Theme> => ({
  '--sidekick-pulse': alpha(theme.palette.custom.OV.sys.secondary, 0.45),
  color: theme.palette.custom.OV.sys.secondary,
  backgroundColor: alpha(theme.palette.custom.OV.sys.secondary, 0.14),
  animation: `${movedPulse} 1.8s ease-out 4`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
});
